import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  root: {
    position: `absolute`,
    top: `15%`,
    width: `100%`,
    textAlign: `center`,
    padding: `10px`,
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.text.primary}`,
    borderBottom: `1px solid ${theme.palette.text.primary}`
  }
}));

const ResultsBanner = ({ displayResults }) => {
  const classes = useStyles();
  return <div className={clsx("results", classes.root)}>{displayResults}</div>;
};

export default ResultsBanner;
